export const brand = {
  product: "Asistencia al Docente · Ciclo Lectivo 2027",
  pack: "Megapack Docente Argentino 2027",
  level: "Nivel Primario · 1° ciclo",
  owner: "Practic and simple",
  email: "contacto@practicandsimple.com",
  instagram: "@practicandsimple",
  web: "practicandsimple.com",
  heroImage:
    "https://cdn.magicpatterns.com/patterns/generated-images/f082e065-7c35-48cd-a5bb-a8a8b5aa9980.jpg",
};

export const hero = {
  kicker: "Megapack Docente Argentino 2027 · Nivel Primario, 1° ciclo",
  title: "Todo tu Ciclo Lectivo 2027 Resuelto",
  bigNumber: "6+4",
  bigNumberLabel: "Tomos + Bonos",
  subtitle:
    "Planificá tu año completo en una sola tarde y recuperá más de 5 horas por semana desde el primer día de clases. Planificación, actos, Lengua, Matemática, aula y evaluación: todo listo para imprimir y completar.",
  tags: ["PDF Digital", "Acceso Inmediato", "1°, 2° y 3° grado"],
  cta: "QUIERO MI AÑO LECTIVO RESUELTO AHORA",
  trust: ["Garantía 7 días", "Pago seguro", "Mercado Pago"],
  stats: [
    { value: "+500", label: "Docentes" },
    { value: "4.9", label: "Rating" },
    { value: "Todo", label: "Argentina" },
  ],
};

export const testimonials = [
  {
    quote:
      "Armé toda mi planificación anual en una tarde de febrero. Llegué al primer día de clases con marzo y abril listos, sin pasar el fin de semana frente a la compu.",
    name: "Laura G.",
    detail: "La Plata — Maestra de 2° grado",
  },
  {
    quote:
      "El acto del 25 de Mayo lo resolví en 20 minutos: guion, ambientación y lista de chequeo. Antes me llevaba una semana entera buscar ideas y recortar.",
    name: "Carolina P.",
    detail: "Rosario — Docente de 1° grado",
  },
  {
    quote:
      "Con las rúbricas y los modelos de informe cerré el primer trimestre en 2 horas, no en 2 fines de semana. Volví a tener mis domingos.",
    name: "Mariela S.",
    detail: "Córdoba — Maestra de 3° grado",
  },
];

export const painPoints = {
  eyebrow: "¿TE PASA ESTO?",
  title: "Si sos docente de primer ciclo en Argentina, esto te suena familiar:",
  items: [
    { title: "Domingos planificando", text: "Te pasás el fin de semana armando la semana que viene." },
    { title: "Actos a último momento", text: "Cada fecha patria te encuentra buscando guiones y recortando." },
    { title: "Fichas que no enganchan", text: "Actividades sueltas de Pinterest que no encajan con tu grupo." },
    { title: "Aula sin rutinas", text: "Los chicos no saben qué sigue y perdés minutos valiosos ordenando." },
    { title: "Evaluar te desborda", text: "Registros, rúbricas e informes se acumulan a fin de trimestre." },
    { title: "Un grado, mil niveles", text: "No sabés cómo adaptar la misma consigna para todos." },
    { title: "Faltás y no hay plan", text: "El suplente llega sin nada preparado y se pierde el día." },
    { title: "Mensajes a familias", text: "Escribís cada comunicado desde cero, una y otra vez." },
  ],
  closing: "¿Cuántos domingos más vas a perder planificando?",
  prompt: "Tocá las que te pasan",
  resultFew: "Esto tiene solución, y lleva una tarde.",
  resultMany: "Este megapack está hecho para vos.",
  resultCta: "Ver la solución",
};

export const audience = {
  eyebrow: "¿PARA QUIÉN ES?",
  title: "Diseñado para vos si querés empezar el 2027 con todo resuelto",
  items: [
    { title: "Docentes de 1°, 2° y 3° grado", text: "Que quieren llegar a marzo con la planificación anual lista y las primeras semanas armadas.", isNew: false },
    { title: "Maestras y maestros con doble turno", text: "Poco tiempo y muchos chicos: material listo para imprimir y usar al día siguiente.", isNew: false },
    { title: "Docentes recién recibidos", text: "Tu primer año frente al aula, con todo el material y el orden que nadie te dio en el profesorado.", isNew: true },
    { title: "Suplentes y reemplazos", text: "Llegás a un grado nuevo y necesitás dar una clase completa hoy mismo.", isNew: false },
  ],
  guaranteeLink: "¿No sabés si es para vos? Tenés 7 días de garantía →",
};

export const system = {
  eyebrow: "EL MEGAPACK N°1 PARA DOCENTES DE PRIMER CICLO",
  summary: "Sistema completo · 6 Tomos + 4 Bonos · Nivel Primario, 1° ciclo · Todo resuelto.",
  stats: [
    { value: "+360 pág.", label: "listas para imprimir" },
    { value: "+200", label: "fichas y actividades" },
  ],
  tags: ["Planificación", "Secuencias", "Proyectos", "Efemérides", "Actos", "Lengua", "Matemática", "Alfabetización", "Rutinas", "Carteles", "Evaluación", "Rúbricas", "Informes", "Familias"],
  note: "Funciona desde hoy: descargás, imprimís, completás y das clase.",
  areasTitle: "Áreas y recursos incluidos:",
  areas: ["Planificación anual", "Secuencias didácticas", "Fechas patrias", "Lectura y escritura", "Resolución de problemas", "Juegos matemáticos", "Ambientación del aula", "Diagnóstico", "Rúbricas", "Informes"],
};

export const tomos = [
  {
    code: "T1",
    title: "Planificá en una tarde",
    subtitle: "Tu año completo en 4 horas",
    description:
      "Planificación anual, secuencias, proyectos y clases, listos para completar. Seguís el paso a paso, ajustás a tu grupo y en una sola tarde tenés el año organizado de marzo a diciembre.",
    bullets: ["Planificación anual lista para completar", "Secuencias didácticas y proyectos por trimestre", "Modelos de clase con inicio, desarrollo y cierre"],
  },
  {
    code: "T2",
    title: "Actos y efemérides sin estrés",
    subtitle: "Cada fecha patria en 20 minutos",
    description:
      "Calendario, guiones, ambientación y listas de chequeo para cada fecha patria. Sabés qué hacer, quién dice qué y qué preparar, con semanas de anticipación.",
    bullets: ["Calendario de efemérides 2027", "Guiones listos para cada acto", "Ambientación y lista de chequeo por fecha"],
  },
  {
    code: "T3",
    title: "Lengua: leer y escribir en el aula",
    subtitle: "Alfabetización que avanza",
    description:
      "Fichas, consignas y rutinas listas para imprimir. Actividades de lectura y escritura con progresión clara para que cada chico avance a su ritmo.",
    bullets: ["Fichas de lectura y escritura", "Consignas graduadas por nivel", "Rutinas diarias de alfabetización"],
  },
  {
    code: "T4",
    title: "Matemática: problemas que enganchan",
    subtitle: "Chicos que piensan y juegan",
    description:
      "Fichas, juegos y problemas listos para imprimir. Situaciones que despiertan la curiosidad y hacen que el número tenga sentido.",
    bullets: ["Problemas con contexto cotidiano", "Juegos matemáticos para el aula", "Fichas de cálculo y numeración"],
  },
  {
    code: "T5",
    title: "Aula ordenada y linda",
    subtitle: "Tu aula lista antes del primer día",
    description:
      "Carteles, rutinas, rincones y horarios listos para imprimir. Un aula que se organiza sola y donde los chicos saben qué sigue.",
    bullets: ["Carteles y ambientación imprimibles", "Rutinas visuales y horarios", "Rincones de trabajo armados"],
  },
  {
    code: "T6",
    title: "Evaluá sin perder el domingo",
    subtitle: "Cerrá el trimestre en 2 horas",
    description:
      "Diagnóstico, rúbricas, registro, informes y reuniones con familias. Todo el circuito de evaluación resuelto, de la primera semana al cierre del año.",
    bullets: ["Evaluación diagnóstica lista", "Rúbricas y registro de seguimiento", "Modelos de informe y guía para reuniones con familias"],
  },
];

export const bonuses = {
  eyebrow: "INCLUIDOS GRATIS",
  title: "4 Bonos Estratégicos",
  subtitle: "Sin costo extra — incluidos en todas las ofertas",
  items: [
    {
      code: "B1",
      title: "Plan B del suplente",
      text: "20 clases comodín de 40 minutos, para dar hoy con lo que tengas a mano.",
      image: "https://cdn.magicpatterns.com/patterns/generated-images/a741a8e4-d5ce-4699-842e-999475b04cb9.jpg",
    },
    {
      code: "B2",
      title: "Carpeta del docente lista para imprimir",
      text: "Portadas, índice, asistencia, registro, comunicados y agenda.",
      image: "https://cdn.magicpatterns.com/patterns/generated-images/cdcd69a8-e001-4a78-a155-504aa5f39c9c.jpg",
    },
    {
      code: "B3",
      title: "Calendario del docente 2027",
      text: "Feriados, efemérides y espacios para planificar todo el año.",
      image: "https://cdn.magicpatterns.com/patterns/generated-images/79baa9c5-a9fd-4520-840f-d5b4bbc22600.jpg",
    },
    {
      code: "B4",
      title: "50 mensajes y comunicados para familias",
      text: "Listos para copiar, completar y enviar.",
      image: "https://cdn.magicpatterns.com/patterns/generated-images/aa098f8a-9173-4271-8988-19096d918aa7.jpg",
    },
  ],
  totalValue: "VALOR TOTAL: $32.000 — GRATIS",
};

export const costComparison = {
  eyebrow: "LA REALIDAD",
  title: "¿Cuánto cuesta NO tenerlo?",
  without: "Sin el megapack",
  with: "Con el megapack",
  rows: [
    ["5 a 8 hs por semana buscando y armando material", "15 min por semana eligiendo e imprimiendo"],
    ["Planificación anual que lleva semanas", "Año completo planificado en una tarde"],
    ["Actos armados a último momento", "Guion, ambientación y checklist por fecha"],
    ["Fichas sueltas de Pinterest sin hilo", "Secuencias de Lengua y Matemática con progresión"],
    ["Domingos corrigiendo y escribiendo informes", "Rúbricas y modelos de informe listos"],
    ["Aula desordenada y sin rutinas", "Carteles, rincones y horarios listos para imprimir"],
    ["Comunicados escritos desde cero", "50 mensajes para familias listos para enviar"],
    ["Faltar sin dejar plan al suplente", "20 clases comodín de 40 minutos"],
  ],
};

export const offer = {
  live: "Oferta en vivo",
  priceUp: "+$8.000 DESPUÉS",
  endsIn: "LANZAMIENTO TERMINA EN",
  noReturn: "Y no vuelve a bajar",
  spotsLabel: "Cupos restantes",
  spotsTaken: 68,
  title: "Elegí tu Ciclo Lectivo 2027 Resuelto",
  subtitle: "Ambas opciones incluyen los 4 bonos estratégicos completos",
  plans: [
    {
      id: "basic",
      name: "MEGAPACK DOCENTE",
      includes: "6 tomos + 4 bonos estratégicos",
      price: "$14.999",
      oldPrice: "$24.999",
      cta: "QUIERO EL MEGAPACK",
      checkoutUrl: "https://checkout.practicandsimple.shop/cart/67643151188337:1",
      featured: false,
    },
    {
      id: "full",
      name: "PACK COMPLETO",
      includes: "6 tomos + 4 bonos + 2 Premium",
      price: "$19.999",
      oldPrice: "$35.999",
      cta: "SÍ, QUIERO PACK COMPLETO",
      checkoutUrl: "https://checkout.practicandsimple.shop/cart/67643154792817:1",
      featured: true,
      badge: "MÁS ELEGIDO",
      savings: "AHORRÁS $16.000",
    },
  ],
  featuredNote: "La opción más elegida por docentes que quieren un año sin improvisar",
  trust: ["Pago seguro", "Acceso en 5 min", "Garantía 7 días", "Mercado Pago"],
};

export const premium = {
  eyebrow: "¿QUÉ AGREGA EL PACK PREMIUM?",
  subtitle: "Para docentes que quieren ir un paso más allá: proyectos que se lucen y un aula donde nadie queda atrás",
  slides: [
    {
      title: "Proyectos que se lucen",
      problem: "Proyectos armados a las apuradas",
      without: "Improvisás un proyecto para la muestra y no se integra con lo que diste en el año.",
      with: "3 proyectos integrados con secuencia, producto final y evaluación, listos para aplicar.",
    },
    {
      title: "Una consigna, tres niveles",
      problem: "Un grado con niveles muy distintos",
      without: "Algunos terminan en 5 minutos y otros no logran arrancar.",
      with: "Cada consigna en tres niveles para que todos trabajen en su punto justo, al mismo tiempo.",
    },
    {
      title: "Nadie queda atrás",
      problem: "Chicos que necesitan refuerzo",
      without: "Detectás dificultades pero no tenés tiempo de armar material de apoyo.",
      with: "Plan de refuerzo listo para acompañar a quienes más lo necesitan.",
    },
    {
      title: "Clases que no se repiten",
      problem: "Siempre la misma dinámica",
      without: "Pizarrón y cuaderno todos los días, y el grupo se dispersa.",
      with: "Estaciones de trabajo rotativas que mantienen a todos activos y concentrados.",
    },
  ],
  includesTitle: "EL PACK PREMIUM INCLUYE:",
  includes: [
    { code: "P1", title: "Proyectos que lucen", text: "3 proyectos integrados listos para aplicar en el aula." },
    { code: "P2", title: "Aula diversa", text: "Una consigna, tres niveles: fichas, estaciones y plan de refuerzo." },
  ],
};

export const guarantee = {
  days: "7 DÍAS",
  label: "GARANTÍA TOTAL",
  title: "7 días para probarlo o te devolvemos el 100%",
  text: "Abrís los tomos, imprimís las fichas y las probás en tu aula. Si no es lo que esperabas: sin preguntas, sin formularios, sin drama. (Tasa de devoluciones < 1%)",
};

export const faqs = [
  {
    q: "¿Cómo recibo el megapack después de comprar?",
    a: "Apenas se acredita el pago te llega un email con el acceso para descargar todos los tomos y bonos en PDF. Lo podés abrir desde la compu, el celular o la tablet e imprimir cuando quieras.",
  },
  {
    q: "¿Sirve para 1°, 2° y 3° grado?",
    a: "Sí. Está pensado para todo el primer ciclo de Nivel Primario. Las fichas y consignas están graduadas para que elijas el nivel que corresponde a tu grupo.",
  },
  {
    q: "¿Está adaptado a la currícula argentina?",
    a: "Sí. Está armado a partir de los Núcleos de Aprendizajes Prioritarios del primer ciclo y es completable, así lo ajustás en minutos al diseño curricular de tu provincia.",
  },
  {
    q: "¿Necesito impresora color?",
    a: "No. Todo el material funciona perfecto impreso en blanco y negro. Si tenés color, los carteles y la ambientación lucen todavía más.",
  },
  {
    q: "¿Los 4 bonos están incluidos en las dos ofertas?",
    a: "Sí. Tanto el Megapack Docente como el Pack Completo incluyen los 4 bonos estratégicos sin costo extra.",
  },
  {
    q: "¿Sirve si soy suplente o recién recibido?",
    a: "Es ideal. Tenés planificación, clases comodín y material para dar clase desde el primer día, aunque llegues a un grado que no conocés.",
  },
  {
    q: "¿Qué diferencia tiene con el material gratis de Pinterest o grupos de docentes?",
    a: "El material gratis está suelto y no sigue una secuencia. Acá tenés un sistema completo y ordenado para todo el año: planificación, actos, áreas, aula y evaluación conectados entre sí.",
  },
  {
    q: "¿Por qué elegir el Pack Completo y no el Megapack?",
    a: "Porque suma los 2 Premium: 3 proyectos integrados que se lucen y el Aula diversa, con consignas en tres niveles y plan de refuerzo. Es lo que más tiempo ahorra cuando el grupo es heterogéneo.",
  },
  {
    q: "¿Tiene garantía real?",
    a: "Sí. Tenés 7 días para revisarlo. Si no es lo que esperabas, nos escribís y te devolvemos el 100% de tu dinero, sin preguntas.",
  },
];

export const finalCta = {
  title: "No dejes pasar esta oportunidad",
  endsIn: "Termina en",
};

export const footer = {
  tagline:
    "El megapack N°1 para docentes de primer ciclo en Argentina. Porque enseñar no debería costarte tus fines de semana.",
  copyright: "© Practic and simple 2026 — Todos los derechos reservados.",
};
